import type { PaginationFilters } from '@reliance/types/filters/PaginationFilters';
import type { PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { useAsync } from 'react-async-hook';
import api from '../common/api';

export type SaltMinionListItem = {
  id: string;
};

export type SaltMinionUpdate = {
  id?: string;
  sls?: string;
  function?: string;
  name?: string;
  changelog?: string;
  comment?: string;
  changes?: {
    diff?: string;
  };
};

export type SaltMinionDetails = {
  id: string;
  grains: Record<string, any>;
  updates: SaltMinionUpdate[];
};

export type SaltMinionFilters = PaginationFilters & {
  facilityId?: number;
  orderBy?: string;
};

export const useSaltMinions = (filters?: SaltMinionFilters) =>
  useAsync<PaginatedResponse<SaltMinionListItem>>(
    () =>
      api
        .get<PaginatedResponse<SaltMinionListItem>>('/salt/minion', { params: filters })
        .then((r) => r.data),
    [filters]
  );

export const useSaltMinion = (id: string | null | undefined) =>
  useAsync<SaltMinionDetails | null>(
    async () => {
      if (!id) {
        return null;
      }
      const response = await api.get<SaltMinionDetails>(`/salt/minion/${id}`);
      return response.data;
    },
    [id]
  );
